import { pushEvent } from "./utils";

/**
 * inits iPaper products data layer view
 */
const initDataLayerEvents = () => { 
    document.addEventListener("dataLayer.iPaperClickEvents", event => {
        const { title, link } = event?.detail || {};
    
        if (title && link) {
            pushEvent("iPaperClickEvents", {
                customFields: {
                    name: title,
                    link: link
                }
            });
        }
    });    
};

module.exports = {
    initDataLayerEvents: initDataLayerEvents
};
